export default __webpack_public_path__ + "static/media/IWBF-Logo.3b7e3126.webp";